import { useLocation, useNavigate } from "react-router-dom";
import BackArrowIcon from "../components/icons/BackArrowIcon";
import SignInCard from "../modals/SignInCard";

function Home() {
  const location = useLocation();
  const navigate = useNavigate();
  const cardKey = location.state?.sessionResetAt || "auth";

  // Reverse transition back to welcome; replace so history doesn't stack /login.
  const goWelcome = () => navigate("/", { replace: true });

  return (
    <div className="homePage">
      <button type="button" className="galleryPage__back homePage__back" onClick={goWelcome}>
        <BackArrowIcon />
        Back
      </button>
      <SignInCard key={cardKey} />
    </div>
  );
}

export default Home;
